import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import './application.css'

const pages = import.meta.glob('../pages/**/*.tsx', { eager: true }) as Record<string, { default: React.ComponentType<any> }>

createInertiaApp({
  id: 'app',
  resolve: (name) => {
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      console.error(`Page not found: ${name}. Available pages:`, Object.keys(pages))
      throw new Error(`Page not found: ${name}`)
    }
    return page
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
